import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CardSubType } from '@bciti/types';

@Component({
    selector: 'app-card-subtype',
    templateUrl: './card-subtype.component.html',
    styleUrls: ['./card-subtype.component.scss'],
})
export class CardSubtypeComponent implements OnInit {
    @Input()
    card: FormGroup;

    @Output() eventClicked = new EventEmitter<any>();

    constructor() {}

    ngOnInit(): void {}

    subTypeChange(): void {
        this.eventClicked.emit({
            availableSubTypes: (this.card.get('availableSubTypes') as FormArray).value,
        });
    }

    getSubTypes(): string[] {
        return Object.values(CardSubType);
    }
}
